module.exports = __webpack_public_path__ + "img/Fetu_o_Siva_Polynesian_Dance_Academy.ebbd9160.png";